import { Record } from 'immutable';

const LogLineRecordClass = Record({
  key: null,
  level: null,
  message: null,
  time: null,
  timestamp: null,
  processId: null,
});

class LogLineRecord extends LogLineRecordClass { }

export {
  LogLineRecord,
};
